export default function PhilosophySection() {
  return (
    <section className="w-full bg-background-100">
      <div className="px-6 md:px-10 py-16 md:py-24">
        <div className="max-w-[560px]">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground-950 leading-[1.2] tracking-tight">
            Built on Rigorous Engineering Principles
          </h2>
        </div>
      </div>
    </section>
  );
}